import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

export type CardWidth = 'none' | 'narrow' | 'medium' | 'wide';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  width?: CardWidth;
}

export default function Card({ children, width = 'none', className = '', ...rest }: CardProps) {
  const widthClass =
    width === 'narrow'
      ? styles.narrow
      : width === 'medium'
        ? styles.medium
        : width === 'wide'
          ? styles.wide
          : '';

  return (
    <div className={`${styles.card} ${widthClass} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}
